<template>
  <PalettePicker 
    ref="dropdown"
    :boundary="boundary"
    v-model="colorValue" 
    :alpha.sync="colorAlpha"
    @shown="emaitShown"
    @show="onShow"
    @hide="onHide"
  >
    <template #icon v-if="$slots.icon">
      <slot name="icon"></slot> 
    </template>
  </PalettePicker>
</template>

<script>
import PalettePicker from "@components_system/Shared/Tools/Box/PalettePicker/PalettePicker";

export default {
  components: {
    PalettePicker,
  },
  computed: {
    colorValue: {
      get() {
        return this.data || this.color;
      },
      set(value) {
        this.$emit("input", value);
        this.$emit("input:color", value);
        this.$emit("update:color", value);
        this.emitColor(value);
      },
    },
    colorAlpha: {
      get() {
        return this.alpha;
      },
      set(value) {
        this.$emit("input:alpha", value);
        this.$emit("update:alpha", value);
        this.emitAlpha(value);
      },
    },
  },
  methods: {
    emitColor(value) {
      this.$emit("change", value);
      this.$emit("change:color", value);
    },
    emitAlpha(value) {
      this.$emit("change:alpha", value);
    },
    emaitShown() {
      this.$emit("shown");
    },
    show() {
      this.$refs.dropdown.palatteShown();
    },
    onShow(event) {
      this.$emit("show", event);
    },
    onHide(event) {
      this.$emit("hide", event);
    },
  },
  props: {
    data: {
      // default: "#000000",
      // required: true,
      // type: String,
    },
    color: {
      // default: "#000000",
      // required: true,
      // type: String,
    },
    alpha: {
      // default: "#000000",
      // required: true,
      // type: String,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
    boundary: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style>
</style>